/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DelegationOverviewDashboardResponse } from '../../models/delegation-overview-dashboard-response';

export interface GetDeletationOverview$Params {

/**
 * Filters delegations that have their created date after or same as the provided date.
 * Expects date-time in <YYYY-MM-DDTHH:mm:ss.SSSZ> format
 */
  from: string;

/**
 * Filters delegations that have their created date before or same as the provided date.
 * Expects date-time in <YYYY-MM-DDTHH:mm:ss.SSSZ> format
 */
  to: string;
}

export function getDeletationOverview(http: HttpClient, rootUrl: string, params: GetDeletationOverview$Params, context?: HttpContext): Observable<StrictHttpResponse<DelegationOverviewDashboardResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeletationOverview.PATH, 'get');
  if (params) {
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DelegationOverviewDashboardResponse>;
    })
  );
}

getDeletationOverview.PATH = '/api/administration/dashboard/users/delegation-overview';
